import React, { useState, useRef, useEffect, useCallback } from "react";
const services = [{
  title: "Խճանկարների պատրաստում",
  image: {
    src: "https://summary-monarch.10web.cloud/wp-content/uploads/2026/05/98bb0819-a39e-4e3b-aeda-7d8fffc78919-2.png?v=mvj6agpradp",
    srcset: "https://summary-monarch.10web.cloud/wp-content/uploads/2026/05/98bb0819-a39e-4e3b-aeda-7d8fffc78919-2.png?v=slv7i9xs9n-wvc-srcset",
    sizes: "https://summary-monarch.10web.cloud/wp-content/uploads/2026/05/98bb0819-a39e-4e3b-aeda-7d8fffc78919-2.png?v=xix5prn0ywg-wvc-sizes",
    alt: "High-resolution aerial mosaic of urban buildings"
  }
}, {
  title: "Արբանյակային պատկերների մշակում",
  image: {
    src: "https://summary-monarch.10web.cloud/wp-content/uploads/2026/05/46f02b94-fec7-4c59-a271-1c5e87829f90-2.png?v=6og3sbrph8p",
    srcset: "https://summary-monarch.10web.cloud/wp-content/uploads/2026/05/46f02b94-fec7-4c59-a271-1c5e87829f90-2.png?v=qfloahladce-wvc-srcset",
    sizes: "https://summary-monarch.10web.cloud/wp-content/uploads/2026/05/46f02b94-fec7-4c59-a271-1c5e87829f90-2.png?v=fylkfw48x4-wvc-sizes",
    alt: "Satellite imagery demonstrating cloud masking techniques"
  }
}];
export default function PhotogrammetryServicesGrid() {
  const [sliderPosition, setSliderPosition] = useState(50);
  const [isDragging, setIsDragging] = useState(false);
  const sliderRef = useRef(null);
  const handleMove = useCallback(clientX => {
    if (!sliderRef.current) return;
    const rect = sliderRef.current.getBoundingClientRect();
    const x = Math.max(0, Math.min(clientX - rect.left, rect.width));
    const percent = x / rect.width * 100;
    setSliderPosition(percent);
  }, []);
  const onMouseMove = useCallback(e => {
    if (isDragging) handleMove(e.clientX);
  }, [isDragging, handleMove]);
  const onTouchMove = useCallback(e => {
    if (isDragging) {
      e.preventDefault();
      handleMove(e.touches[0].clientX);
    }
  }, [isDragging, handleMove]);
  const onMouseUp = useCallback(() => {
    setIsDragging(false);
  }, []);
  useEffect(() => {
    window.addEventListener("mousemove", onMouseMove);
    window.addEventListener("mouseup", onMouseUp);
    window.addEventListener("touchmove", onTouchMove, {
      passive: false
    });
    window.addEventListener("touchend", onMouseUp);
    return () => {
      window.removeEventListener("mousemove", onMouseMove);
      window.removeEventListener("mouseup", onMouseUp);
      window.removeEventListener("touchmove", onTouchMove);
      window.removeEventListener("touchend", onMouseUp);
    };
  }, [onMouseMove, onMouseUp, onTouchMove]);
  return <section id="photogrammetryservicesgrid" className="bg-background py-16 md:py-24 light">
      <div className="container mx-auto px-4 md:px-6">
        
        

        {/* --- Interactive Image Slider Section --- */}
        <div className="max-w-4xl mx-auto mb-20">
          <div className="flex flex-col md:flex-row justify-between items-end mb-6 gap-4">
            <div>
              <h3 className="text-2xl font-bold text-foreground mb-2">Արբանյակային պատկերի սպետկրալ վերլուծություն</h3>
              
            </div>
          </div>

          <div ref={sliderRef} className="relative w-full aspect-[16/9] md:aspect-[21/9] overflow-hidden rounded-xl border border-border/40 shadow-lg select-none cursor-crosshair" onMouseDown={e => {
          setIsDragging(true);
          handleMove(e.clientX);
        }} onTouchStart={e => {
          setIsDragging(true);
          handleMove(e.touches[0].clientX);
        }}>
            {/* AFTER IMAGE (Right - Clean Orthophoto) */}
            <img src="https://summary-monarch.10web.cloud/wp-content/uploads/2026/06/image172.png" alt="Processed Orthophoto" className="absolute inset-0 w-full h-full object-cover pointer-events-none" />

            {/* BEFORE IMAGE (Left - Raw Polygons) */}
            <img src="https://summary-monarch.10web.cloud/wp-content/uploads/2026/06/image173.png" alt="Raw Aerial Images" className="absolute inset-0 w-full h-full object-cover pointer-events-none" style={{
            clipPath: `inset(0 ${100 - sliderPosition}% 0 0)`,
            filter: "drop-shadow(2px 0 10px rgba(0,0,0,0.5))"
          }} />

            <div className="absolute top-0 bottom-0 w-1 bg-white z-10 flex items-center justify-center cursor-ew-resize shadow-[0_0_10px_rgba(0,0,0,0.3)]" style={{
            left: `${sliderPosition}%`,
            transform: 'translateX(-50%)'
          }}>
              <div className="w-8 h-8 bg-white rounded-full flex items-center justify-center shadow-md text-slate-800 font-bold text-sm">
                ↔
              </div>
            </div>
          </div>
        </div>

        {/* Existing Services Grid */}
        

      </div>
    </section>;
}